import React from "react";

/**
 * Shared SSO card shell: white panel over the branded page background.
 * @param {{children: React.ReactNode, tailwindProps?: string}} props
 */
const AuthForm = ({ children, tailwindProps = "" }) => {
  return (
    <div className={`auth-card ${tailwindProps}`}>
      {children}
    </div>
  );
};

export default AuthForm;
